import React, { useMemo } from 'react';
import axios from 'axios';
import { useApp } from '../context/AppContext';
import { ProductsReport } from '../components/products/ProductsReport';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Products() {
  const { selectedProject } = useApp();
  const pid = selectedProject?.id;
  const api = useMemo(() => {
    const base = `${API_URL}/api/products/projects/${pid}`;
    return {
      get: (p, cfg) => axios.get(base + p, cfg),
      post: (p, body) => axios.post(base + p, body),
      put: (p, body) => axios.put(base + p, body),
      createDiagnostic: (url) => axios.post(`${API_URL}/api/diagnostics/projects/${pid}`,
        { project_id: pid, pages: [{ url, page_type: 'produto', source: 'manual' }] }),
    };
  }, [pid]);
  if (!pid) return <div className="text-center py-12">Selecione um projeto</div>;
  return <ProductsReport key={pid} api={api} />;
}
